import React from 'react';
import classNames from 'classnames';

import css from './IconCart.module.css';

/**
 * Cart icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @returns {JSX.Element} SVG icon
 */
const IconCart = props => {
  const { className } = props;
  const classes = classNames(css.root, className);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.01 4H5.06L3.95 0.680003C3.88291 0.481382 3.7551 0.308868 3.58463 0.186845C3.41416 0.0648223 3.20964 -0.000537828 3 3.33354e-06H0V2H2.28L5.82 12.63C5.95246 13.0291 6.20736 13.3763 6.54845 13.6223C6.88954 13.8682 7.29948 14.0004 7.72 14H15.31C15.7169 13.9993 16.114 13.8745 16.4481 13.6422C16.7822 13.4099 17.0376 13.0812 17.18 12.7L19.94 5.35C19.9971 5.19929 20.0167 5.03698 19.9973 4.877C19.9779 4.71701 19.92 4.56411 19.8286 4.4314C19.7372 4.29868 19.615 4.19011 19.4724 4.11498C19.3298 4.03984 19.1712 4.00039 19.01 4ZM8.01 16C7.47957 16 6.97086 16.2107 6.59579 16.5858C6.22071 16.9609 6.01 17.4696 6.01 18C6.01 18.5304 6.22071 19.0391 6.59579 19.4142C6.97086 19.7893 7.47957 20 8.01 20C8.54043 20 9.04914 19.7893 9.42421 19.4142C9.79928 19.0391 10.01 18.5304 10.01 18C10.01 17.4696 9.79928 16.9609 9.42421 16.5858C9.04914 16.2107 8.54043 16 8.01 16ZM15.01 16C14.4796 16 13.9709 16.2107 13.5958 16.5858C13.2207 16.9609 13.01 17.4696 13.01 18C13.01 18.5304 13.2207 19.0391 13.5958 19.4142C13.9709 19.7893 14.4796 20 15.01 20C15.5404 20 16.0491 19.7893 16.4242 19.4142C16.7993 19.0391 17.01 18.5304 17.01 18C17.01 17.4696 16.7993 16.9609 16.4242 16.5858C16.0491 16.2107 15.5404 16 15.01 16Z"
        fill="#64748B"
      />
    </svg>
  );
};

export default IconCart;
